import domtoimage from "dom-to-image";
export const getSnapshot = (isMasterSlide = false) => {
  const containerId = isMasterSlide ? 'master01' : 'slide01';
  return domtoimage.toSvg(document.getElementById('slide01'), {
   // width: window.screen.width > 2200 ? "1800px" : window.screen.width > 1540 ? '1200px': window.screen.width > 1200 ?  '960px' : window.screen.width > 992 ? '848px':window.screen.width > 768 ? '700px' : window.screen.width > 490 ? '490px': '300px',
    // height: window.screen.width > 2200 ? '1020px': window.screen.width > 1540 ? '700px': window.screen.width > 1200 ? '540px' : window.screen.width > 992 ? '500px': window.screen.width > 768 ? '400px': window.screen.width > 490 ? '290px': '180px', 
  });
};
